module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/conduct.json
// module id = 383
// module chunks = 173240281792299